import type { StrokeNib } from "./stroke-outline";

/** Agent pen: mid-weight nib, long tapers. */
export const AGENT_NIB: StrokeNib = { size: 3.2, taper: [14, 22] };

/** Arrow head flicks: the first lands on the tip, the second leaves it. */
export const HEAD_TAPERS: readonly [StrokeNib["taper"], StrokeNib["taper"]] = [
  [6, 4],
  [4, 6],
];

/** The bracket beside a handwritten note. */
export const BRACKET_NIB: StrokeNib = { size: AGENT_NIB.size, taper: [6, 8] };

/** The user's own ink: a slightly broader nib. */
export const USER_NIB: StrokeNib = { size: 3.6, taper: [10, 16] };

export const INK_ALPHA = 0.92;

/** The see-through highlighter band laid over one line of text. */
export const MARKER_ALPHA = 0.28;
export const MARKER_TAPER: StrokeNib["taper"] = [2, 3];

/** The marker band follows the line height: 0.9·h within 8–28 px. */
export function markerNibSize(height: number): number {
  return Math.max(8, Math.min(28, 0.9 * height));
}

/** Finished user strokes fade to this opacity. */
export const USER_INK_COMPLETE_OPACITY = 0.78;

/** How far a box's sketch ink may reach beyond its content box: corner
 * jitter, edge bow, the overshoot lift and half the strongest nib. Every mark
 * keeps at least this; loops grow it with their size (annotationInkOverflow). */
export const SKETCH_INK_OVERFLOW_PX = 14;
